<template>
    <article>
        <table class="ui table" :class="classes">
            <thead>
                <tr>
                    <th :key="header" v-for="header in headers">{{ header }}</th>
                </tr>
            </thead>
            <tbody>
                <tr class="top aligned" :key="item.id" v-for="item in items" @click="$emit('selected', item)">
                    <slot name="row" :item="item" />
                </tr>
                <tr v-if="items.length === 0 && loading === false">
                    <td :colspan="headers.length" class="center aligned">Nothing to display</td>
                </tr>
            </tbody>
            <tfoot class="full-width">
                <slot name="footer"></slot>
            </tfoot>
        </table>
        <app-loader v-if="loading === true"></app-loader>
    </article>
</template>

<script>
export default {
    props: {
        headers: { type: Array },
        items: { type: Array, default: () => [] },
        loading: { type: Boolean },
        classes: { type: String },
    },
}
</script>

<style scoped>

</style>
